<template>
    <div class="globalInquiry" :class="{ dark: this.dark }">
        <Loader :isActive="true"></Loader>
        <div class="title">
            <h3>Minhas dúvidas</h3>
            <button class="newInquiry" @click="openDialogNewInquiry">
                Nova dúvida
            </button>
        </div>
        <div class="itemInquiry" v-for="(item, index) in data" :key="index">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <p class="subtitle">
                    Enviado dia {{ formatarData(item.dateInsert) }}
                </p>
                <button class="delete-inquiry-btn" @click="openDeleteModal(item, index)">
                    <i class="pi pi-trash"></i>
                </button>
            </div>
            <div
                @click="toggleInquiry(index)"
                class="inquiry-header"
                :class="{ active: activeInquiries[index] }"
            >
                <div class="d-flex justify-content-between align-items-center">
                    <h3 class="title-inquiry">{{ item.title }}</h3>
                    <div class="toggle-icon-inquiry">
                        <i
                            class="pi"
                            :class="[
                                activeInquiries[index]
                                    ? 'pi-chevron-up'
                                    : 'pi-chevron-down',
                            ]"
                        ></i>
                    </div>
                </div>
            </div>

            <div v-show="activeInquiries[index]">
                <div
                    class="description-inquiry mb-4 mb-md-5"
                    v-html="item.description"
                ></div>

                <div class="reply">
                    <ReplyInquiry
                        :id="item.id"
                        :messages="item.messages"
                    ></ReplyInquiry>
                </div>

                <div class="waiting" v-show="item.status == 0">
                    Aguardando Resposta
                </div>
                <div class="mt-3">
                    <!-- <QuillEditor theme="snow" toolbar="essential" 
                        v-model:content="comment[index]"
                        contentType="html"/> -->

                    <v-textarea
                        v-model="comment[index]"
                        label="Escreva seu comentário"
                        auto-grow
                        rows="2"
                        outlined
                        class="new-inquiry-textarea"
                    ></v-textarea>

                    <button
                        class="newInquiry mt-3"
                        @click="newComment(item.id, index)"
                    >
                        Novo Comentário
                    </button>
                </div>
            </div>
        </div>
        <v-dialog
            class="new-inquiry-dialog"
            v-model="newInquiryDialog"
            max-width="640"
        >
            <v-card class="dialog-card new-inquiry-dialog__card pa-4 pa-md-7">
                <div class="modal-header mb-4 mb-md-7">
                    <h5 class="modal-title formInquiryStudent">
                        Criar Nova Dúvida
                    </h5>
                </div>
                <v-card-text class="dialog-content p-0">
                    <v-text-field
                        v-model="newInquiry.title"
                        label="Título da Dúvida"
                        required
                        class="dialog-input"
                    ></v-text-field>
                    <v-textarea
                        v-model="newInquiry.description"
                        label="Descrição da Dúvida"
                        required
                        auto-grow
                        rows="8"
                        outlined
                        class="new-inquiry-dialog-textarea"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions class="dialog-actions">
                    <v-btn
                        class="dialog-btn cancel"
                        text
                        @click="newInquiryDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="dialog-btn confirm"
                        text
                        @click="createNewInquiryStudent"
                        :disabled="!newInquiry.title"
                        >Criar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="deletInquiryDialog"
            max-width="500"
            class="delete-inquiry-dialog"
        >
            <v-card class="dialog-card delete-inquiry-dialog__card">
                <div class="modal-header mb-3">
                    <h5 class="modal-title">
                        Deletar Dúvida
                    </h5>
                </div>
                <v-card-text class="dialog-content p-0">
                    <p>Você tem certeza que deseja deletar essa dúvida?</p>
                </v-card-text>
                <v-card-actions class="dialog-actions px-3">
                    <v-btn
                        class="dialog-btn cancel"
                        text
                        @click="deletInquiryDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="dialog-btn confirm"
                        text
                        @click="deletInquiry()"
                        >Deletar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import NewInquiry from '@/components/Student/Dashboard_Unique/Inquiry/New_Inquiry.vue';
    import ReplyInquiry from '@/components/Student/Dashboard_Unique/Inquiry/Reply_Inquiry.vue';
    import Loader from '@/components/Loader/loader.vue';

    import api from '@/utils/portal/inquiry.js';
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';


    export default {
        data() {
            return {
                active: 0,
                data: [],
                hasReady: false,
                comment: [],
                activeInquiries: {},
                newInquiryDialog: false,
                newInquiry: {
                    title: '',
                    description: '',
                },
                deletInquiryDialog: false,
                deletedInquiry: {
                    id: '',
                    index: '',
                },
            };
        },
        props: {},
        computed: {
            ...mapState(['token']),
            ...mapState(['dark']),
        },
        components: {
            NewInquiry,
            ReplyInquiry,
            Loader,
        },
        methods: {
            handleOpenModalInquiry() {
                this.openDialogNewInquiry = false;
            },
            toggleInquiry(index) {
                this.activeInquiries[index] = !this.activeInquiries[index];
            },
            openDialogNewInquiry() {
                this.newInquiryDialog = true;
            },
            async createNewInquiryStudent() {
                const payload = {
                    title: this.newInquiry.title,
                    description: this.newInquiry.description,
                    status: 1,
                };
                try {
                    const response = await api.newInquiry(this.token, payload);
                    this.getDataInquirys();
                    toast.success('Dúvida criada com sucesso!')
                    this.newInquiryDialog = false;
                    this.newInquiry = { title: '', description: '' };
                } catch (error) {
                    toast.error('Erro ao criar dúvida');
                    console.error('Erro ao criar dúvida:', error);
                }
            },
            async getDataInquirys() {
                this.hasReady = false;
                try {
                    const response = await api.getDataListInquiry(this.token);
                    this.data = response;
                    this.activeInquiries[0] = true;
                    this.transformFirstMessagesInDescription();
                    this.hasReady = true;
                } catch (error) {
                    toast.error('Erro ao carregar as dúvidas');
                    console.error('Erro na listagem da notificações');
                }
            },
            formatarData(data) {
                const dataObj = new Date(data);
                const dia = dataObj.getDate();
                const mes = dataObj.getMonth() + 1;
                const ano = dataObj.getFullYear() % 100;

                const diaFormatado = dia < 10 ? '0' + dia : dia;
                const mesFormatado = mes < 10 ? '0' + mes : mes;
                const anoFormatado = ano < 10 ? '0' + ano : ano;

                return `${diaFormatado}/${mesFormatado}/${anoFormatado}`;
            },
            async newComment(id, index) {
                const obj = {
                    message: this.comment[index],
                };
                try {
                    const response = await api.newComment(this.token, obj, id);
                    location.reload();
                } catch (error) {
                    toast.error('Erro ao enviar comentário da dúvida');
                    console.error('Erro ao enviar comentário da dúvida');
                }
            },
            transformFirstMessagesInDescription() {
                if (this.data.length > 0) {
                    for (let i = 0; i < this.data.length; i++) {
                        if (
                            this.data[i].messages &&
                            this.data[i].messages.length > 0
                        ) {
                            const firstMessage = this.data[i].messages.pop(
                                this.data[i].messages.length - 1
                            );
                            this.data[i].description = firstMessage.message;
                        } else {
                            this.data[i].description = '';
                        }
                    }
                }
            },
            openDeleteModal(item, index) {
                this.deletedInquiry.id = item.id;
                this.deletedInquiry.index = index;
                this.deletInquiryDialog = true;
            },
            deletInquiry() {
                const deletedInquiry = this.data.find(
                    (inquiry) => inquiry.id === this.deletedInquiry.id
                );
                const payload = {
                    ...deletedInquiry,
                    status: 9,
                };
                api
                    .updateInquiry(this.token, payload, this.deletedInquiry.id)
                    .then(() => {
                        this.data.splice(this.deletedInquiry.index, 1);
                        this.deletInquiryDialog = false;
                        this.deletedInquiry = { id: '', index: '' };
                    })
                    .catch((error) => {
                        console.error('Erro ao deletar a dúvida:', error);
                    });
            }
        },
        created() {
            this.getDataInquirys();
        },
        watch: {
            openDialogNewInquiry(novoValor) {
                if (novoValor == false) {
                    setTimeout(() => {
                        this.getDataInquirys();
                    }, 1000);
                }
                document.body.style.overflow = novoValor ? 'hidden' : '';
            },
        },
    };
</script>

<style scoped>
    @import url('@/css/weeduc/student/inquiry.css');
</style>
